<template>
  <div class="NewsCon">
    <div class="cont">
      <div class="conBox conBox2">
        <div class="c_left wow slideInLeft" v-if="isShowSwiper">
          <div class="swiper-container" v-swiper:mySwiper="swiperOption">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, index) in memberInfoImgList"
                :key="index"
              >
                <div class="bannerImg">
                  <img :src="item.infoImage" alt="NewsCon" />
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
        <div class="c_right wow slideInRight">
          <div class="new_title">
            <div class="n_lable">会员风采</div>
            <router-link class="btn_more" to="/memberInfo">更多>></router-link>
          </div>
          <ul class="newsList">
            <router-link
              v-for="(item, index) in memberInfoList"
              :key="index"
              :to="'/memberInfoDetails?id=' + item.infoId"
            >
              <li class="newsItem">
                <div class="box_num">{{ index - 0 + 1 }}</div>
                <div class="box_text">
                  <div class="n_title">{{ item.infoName }}</div>
                  <div class="n_desc">
                    {{ item.infoContent }}
                  </div>
                </div>
              </li>
            </router-link>
          </ul>
        </div>
      </div>
      <div class="conBox conBox1">
        <div class="c_box c_left wow slideInLeft">
          <div class="new_title">
            <div class="n_lable">通知公告</div>
            <router-link class="btn_more" to="/announcement"
              >更多>></router-link
            >
          </div>
          <ul class="newsList">
            <router-link
              v-for="(item, index) in announcementList"
              :key="index"
              :to="'/announcementDetails?id=' + item.infoId"
            >
              <li class="newsItem">
                <!-- <div class="box_num">{{ index - 0 + 1 }}</div> -->
                <div class="box_text">
                  <div class="n_title">{{ item.infoName }}</div>
                  <div class="n_time">{{ item.publishTime }}</div>
                  <!-- <div class="n_desc">
                    {{ item.infoContent }}
                  </div> -->
                </div>
              </li>
            </router-link>
          </ul>
        </div>
        <div class="c_box c_right wow slideInRight">
          <div class="new_title">
            <div class="n_lable">行业动态</div>
            <router-link class="btn_more" to="/industryNews"
              >更多>></router-link
            >
          </div>
          <ul class="newsList">
            <router-link
              v-for="(item, index) in industryNewsList"
              :key="index"
              :to="'/industryNewsDetails?id=' + item.infoId"
            >
              <li class="newsItem">
                <div class="box_text">
                  <div class="n_title">{{ item.infoName }}</div>
                  <div class="n_time">{{ item.publishTime }}</div>
                </div>
              </li>
            </router-link>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Swiper from "swiper";
export default {
  name: "NewsCon",
  data() {
    return {
      swiperOption: {
        initialSlide: 0,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        autoResize: true,
        watchActiveIndex: true,
        lazyLoading: true, // 图片懒加载
        lazyLoadingInPrevNext: true,
        preventLinksPropagation: false,
        preventClicks: false,
        visibilityFullFit: true,
        updateOnImagesReady: true, // 所有内部图像（<img>标签）装入后重新初始化Swipe
        calculateHeight: true, // 当值为true时，
        loop: true,
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
        },
      },
      isShowSwiper: false,
      companyNewsList: [],
      //会员风采
      memberInfoList: [],
      memberInfoImgList: [],
      //通知通告
      announcementList: [],
      //行业动态
      industryNewsList: [],
    };
  },
  mounted() {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init();
    });
  },
  created() {
    //通知通告
    this.getInfoManageList({
      PageNo: "1",
      PageSize: "5",
      infoColumn: "1",
    }).then((res) => {
      this.announcementList = res;
    });
    //行业动态
    this.getInfoManageList({
      PageNo: "1",
      PageSize: "5",
      infoColumn: "2",
    }).then((res) => {
      this.industryNewsList = res;
    });
    //会员风采
    this.getInfoManageList({
      PageNo: "1",
      PageSize: "3",
      infoColumn: "3",
    }).then((res) => {
      this.memberInfoList = res;
      if (res.length > 0) {
        this.memberInfoImgList = [...res];
      } else {
        this.memberInfoImgList = [
          {
            infoImage: require("../../assets/img/index/newsCon_img.png"),
          },
        ];
      }
      this.isShowSwiper = true;
    });
  },
  methods: {
    // 获取新闻资讯
    async getInfoManageList({ PageNo, PageSize, infoColumn }) {
      let _that = this;
      let res = await this.$request.getInfoManageList({
        pageNo: PageNo,
        pageSize: PageSize,
        infoColumn: infoColumn,
      });
      res.rows.map((val) => {
        val.infoContent = _that.removeHTMLTag(val.infoContent);
      });
      return res.rows;
      // console.log(res);
    },
    //移除html标签
    removeHTMLTag(str) {
      str = str.replace(/(\n)/g, "");
      str = str.replace(/(\t)/g, "");
      str = str.replace(/(\r)/g, "");
      str = str.replace(/<[^>]+>|&[^>]+;/g, "");
      str = str.replace(/\s*/g, "");
      return str;
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
$themeColor: #003b99;
.NewsCon {
  width: 100%;
  min-width: 1180px;
  overflow: hidden;
  padding: 0 0 46px 0;
  .cont {
    width: 1180px;
    margin: 0 auto;
    .c_title {
      height: 44px;
      padding: 46px 0 0 0;
      position: relative;
      .t_es {
        font-size: 36px;
        font-weight: bold;
        color: #444444;
        opacity: 0.1;
      }
      .t_zh {
        font-size: 24px;
        line-height: 24px;
        font-weight: bold;
        color: $themeColor;
        position: absolute;
        left: 0;
        bottom: 0;
      }
    }
    .conBox1 {
      display: flex;
      justify-content: space-between;
      padding: 40px 0 0 0;
      .c_box {
        width: 566px;
      }
      .new_title {
        display: flex;
        .n_lable {
          width: 120px;
          height: 52px;
          line-height: 52px;
          text-align: center;
          background-color: $themeColor;
          font-size: 18px;
          color: #ffffff;
        }
        .btn_more {
          flex: 1;
          height: 52px;
          line-height: 52px;
          box-sizing: border-box;
          padding: 0 26px 0 14px;
          font-size: 16px;
          color: $themeColor;
          text-align: right;
          background-color: #e9e9e9;
          cursor: pointer;
        }
      }
      .newsList {
        border: solid 1px #e9e9e9;
        border-top: none;
        min-height: 300px;
        a:nth-child(5) .box_text {
          border-bottom: none;
        }
        .newsItem {
          display: flex;
          width: 566px;
          height: 60px;
          line-height: 60px;
          padding: 0 30px;
          box-sizing: border-box;
          cursor: pointer;
          &:hover {
            .box_num {
              color: #ffffff;
              background-color: $themeColor;
            }
            .box_text .n_title,
            .box_text .n_desc {
              color: $themeColor;
            }
          }
          // .box_num {
          //   flex-shrink: 0;
          //   width: 50px;
          //   height: 50px;
          //   line-height: 50px;
          //   text-align: center;
          //   background-color: #dcdcdc;
          //   transition: 0.6s;
          // }

          .box_text {
            display: flex;
            justify-content: space-between;
            width: 100%;
            border-bottom: 1px solid #f0f0f0;
            position: relative;
            &::before {
              display: block;
              content: "";
              width: 5px;
              height: 5px;
              background-color: #003b83;
              border-radius: 50%;
              position: absolute;
              top: 50%;
              left: -16px;
              transform: translate(0, -50%);
            }
            .n_title {
              width: 336px;
              line-height: 60px;
              font-size: 16px;
              transition: 0.6s;
              color: #333333;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
            .n_time {
              line-height: 60px;
              font-size: 14px;
              color: #666;
            }
          }
        }
      }
    }
    .conBox2 {
      display: flex;
      justify-content: space-between;
      padding: 20px 0 0 0;
      .c_left {
        width: 464px;
        height: 310px;
        .bannerImg {
          width: 464px;
          height: 310px;
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
      .c_right {
        width: 670px;
        .new_title {
          display: flex;
          .n_lable {
            width: 158px;
            height: 52px;
            line-height: 52px;
            text-align: center;
            background-color: $themeColor;
            font-size: 18px;
            color: #ffffff;
          }
          .btn_more {
            flex: 1;
            height: 52px;
            line-height: 52px;
            box-sizing: border-box;
            padding: 0 14px;
            font-size: 16px;
            color: $themeColor;
            text-align: right;
            background-color: #e9e9e9;
            cursor: pointer;
          }
        }
        .newsList {
          .newsItem {
            display: flex;
            padding: 36px 0 0 0;
            cursor: pointer;
            &:hover {
              .box_num {
                color: #ffffff;
                background-color: $themeColor;
              }
              .box_text .n_title,
              .box_text .n_desc {
                color: $themeColor;
              }
            }
            .box_num {
              flex-shrink: 0;
              width: 50px;
              height: 50px;
              line-height: 50px;
              text-align: center;
              background-color: #dcdcdc;
              transition: 0.6s;
            }
            .box_text {
              width: 610px;
              padding: 0 0 0 14px;
              .n_title {
                line-height: 30px;
                font-size: 16px;
                transition: 0.6s;
                color: #333333;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              }
              .n_desc {
                line-height: 20px;
                font-size: 14px;
                transition: 0.6s;
                color: #999999;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              }
            }
          }
        }
      }
    }
  }
}
</style>
